import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { MfaFlow } from "@/components/admin/MfaFlow";

export const Route = createFileRoute("/_authenticated/admin/security/verify-mfa")({
  head: () => ({
    meta: [
      { title: "Verificar código | Mostrando México" },
      { name: "description", content: "Confirma tu código de verificación en dos pasos." },
      { property: "og:title", content: "Verificar código | Mostrando México" },
      { property: "og:description", content: "Seguridad de la cuenta administrativa." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: Page,
});

function Page() {
  // Recarga completa: el guard vuelve a evaluar con el token aal2 recién emitido.
  const done = useCallback(() => window.location.replace("/admin"), []);
  return <MfaFlow onVerified={done} />;
}
